module.exports = __webpack_public_path__ + "img/ic-my-filter.0d2e9991.svg";